import {PriceLine2 as APIPriceLine2} from "../../../../api/Pricing";
import {hasPermission, useUser} from "../../../../misc/Permission";
import {api} from "../../../../api/API";
import {
    StringCol,
    Table, ViewOnly
} from "../../../../misc/scroller/Table";
import {priceTableName} from "./Pricing";
import {useProjectId} from "../ProjectName";
import React, {useContext} from "react";
import {ManagerLockContext} from "../ProjectActions";
import {getAll} from "../../../logistics/routes/useGetAll";
import {
    commonPricingColumns3,
    commonPricingColumns3Start,
    sovCellCustomize,
    sovColumns,
    usePricingKit2
} from "./usePricingKit2";
import {SidePricingPanel} from "./SidePricingPanel";
import { onPricingChangeWrap } from "./PricingTabs";
import {
    useCheckboxExtSetupData
} from "../../manage/sov/CheckboxExtProvider";

export type PriceLine2 = APIPriceLine2;

export function Frames(props: {
    sov?: number;
    filterByChangeset?: boolean;
}) {
    const project = useProjectId();
    const {locked} = useContext(ManagerLockContext)
    const u = useUser();

    const kit = usePricingKit2(project);
    const checkboxAllData = useCheckboxExtSetupData();

    if(!u) return null;
    if(kit.Loading) return <>{kit.Loading}</>

    return (
        <div style={{display: "flex", flex: 1, flexDirection: "row", alignItems: "stretch"}}>
            <Table<PriceLine2>
                name={priceTableName(project, "frame")}
                globalPrefsName={priceTableName(0, "frame")}
                cellCustomize={
                    props.sov ? sovCellCustomize(props.sov) :
                        props.filterByChangeset ?
                            undefined :
                            kit.cellCustomize
                }
                locked={locked && !hasPermission(u, "EditShopDrawingWhenLockedToManager")}
                fetch={async (ctx) => checkboxAllData(getAll(ctx, offset =>
                    api.pricing.list({
                        project: project, offset,
                        previewChangeset: kit.sessionId,
                        category: "frame-hm",
                        filterByChangeset: props.filterByChangeset,
                        refunded: props.filterByChangeset ? false : undefined,
                        forSovLink: !!props.sov,
                    })
                ))}
                columns={[
                    ...sovColumns(props.sov),
                    ...commonPricingColumns3Start(),
                    ViewOnly(StringCol("Series", "frame.series", 150)),
                    ViewOnly(StringCol("Material", "frame.material")),
                    ViewOnly(StringCol("Gauge", "frame.gauge")),
                    ViewOnly(StringCol("Screen Elev", "frame.screenElev")),
                    ViewOnly(StringCol("Profile", "frame.profile")),
                    ViewOnly(StringCol("Jamb Depth", "frame.jambDepth")),
                    ViewOnly(StringCol("Door Thickness", "frame.doorThickness")),
                    ViewOnly(StringCol("Construction", "frame.construction")),
                    ViewOnly(StringCol("Handing", "frame.handing")),
                    ViewOnly(StringCol("Label", "frame.label")),
                    ViewOnly(StringCol("Type", "frame.type")),
                    ViewOnly(StringCol("Height", "frame.height")),
                    ViewOnly(StringCol("Width", "frame.width")),
                    ...commonPricingColumns3(u, kit.markup?.frame + "%", props.sov),
                ]}
                columnDeps={[u, kit.markup, props.sov]}
                fetchDeps={[project, kit.sessionId, props.filterByChangeset]}
                onChange={(input) => onPricingChangeWrap(api.pricing.upsert(input))}
            />
            {props.filterByChangeset && <SidePricingPanel
                kind="frame-hm"
                preColumns={[]}
                postColumns={[
                    ViewOnly(StringCol("Series", "frame.series", 150)),
                    ViewOnly(StringCol("Material", "frame.material")),
                    ViewOnly(StringCol("Gauge", "frame.gauge")),
                    ViewOnly(StringCol("Screen Elev", "frame.screenElev")),
                    ViewOnly(StringCol("Profile", "frame.profile")),
                    ViewOnly(StringCol("Jamb Depth", "frame.jambDepth")),
                    ViewOnly(StringCol("Door Thickness", "frame.doorThickness")),
                    ViewOnly(StringCol("Construction", "frame.construction")),
                    ViewOnly(StringCol("Handing", "frame.handing")),
                    ViewOnly(StringCol("Label", "frame.label")),
                    ViewOnly(StringCol("Type", "frame.type")),
                    ViewOnly(StringCol("Height", "frame.height")),
                    ViewOnly(StringCol("Width", "frame.width")),
                ]}
            />}
        </div>
    )
}

